import axios from '../../plugins/axios-common';


export default {
    namespaced: true,
    state: {
        url: '/api/cash/motivity/',
        status: null,
        helpDescription: '',
        nominations: [{},{},{},{},{},{}],
        timeToEnd: 0,
        sliced: '',
        winners: []
    },
    mutations: {
        addData (state, value) {
            state.status = value.status
            state.helpDescription = value.helpDescription
            state.timeToEnd = value.timeToEnd
            let n=value.nominations.length-1
            value.nominations.forEach((nom)=>{
                state.nominations[n]=nom
                n--
            })
            //state.nominations = [...value.nominations]
            state.sliced = value.sliced
            state.winners = value.winners
        },
    },
    actions: {
        getMotivationData ({ rootState, commit, state }) {
            return new Promise((resolve, reject) => {
                if(rootState.master.user && rootState.master.user.id) {
                    axios({
                        method: 'get',
                        url: state.url + rootState.shift.shift.id + '/' + rootState.master.user.id,
                    })
                        .then((response) => {
                            commit('addData', response.data.data)
                            resolve(response)
                        }).catch((e) => {
                        reject(e)
                    })
                } else {
                    reject(new Error('user.id undefined'))
                }
            })
        },
    },
    getters: {
        motivationWinners(state) {
            return state.winners
        }
    },
}
